import React, { useState } from "react";
import { Dialog } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Link, useLocation } from "react-router-dom";
import Logo from './Images/cab-logo.svg';
import call from './Images/call.svg';

const HomeHeader = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    console.log(currentPath, "currentPath")
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <>
            <header className="bg-[#fff] w-full sticky z-10 top-0 shadow-md ">
                <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
                    <div className="flex lg:flex-1">
                        <Link to='/' className="-m-1.5 p-1.5">
                            <div className='flex items-center py-2'>
                                <span className="sr-only">Your Company</span>
                                <img className="shadow-2xl p-1 border border-gray-200 rounded-md h-16 w-16" alt="Logo" src={Logo} />
                                <div className=" text-center ms-1 leading-tight">
                                    <p className=" font-bold text-xl text-[#E8103F] leading-none"> UrbanCab <br /> <span className="text-gray-500">Partner</span></p>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="hidden lg:flex lg:gap-x-12">
                        <a href="tel:+91 97839 66966"
                            className="text-gray-600 text-lg font-semibold flex justify-center items-center gap-2 group hover:text-[#E53935]"><img className=" bg-gray-500 group-hover:bg-[#E53935] h-5 w-5 p-1 rounded-full " alt="call" src={call} />+91 97839 66966
                        </a>
                        <Link to="/" className={` font-medium ${currentPath === "/" ? "text-[#E53935]" : "text-gray-900"}`}>Home</Link>
                        <Link to="/about" className={` font-medium ${currentPath === "/about" ? "text-[#E53935]" : "text-gray-900"}`}>About Us</Link>
                        <Link to="/privacy-policy" className={` font-medium ${currentPath === "/privacy-policy" ? "text-[#E53935]" : "text-gray-900"}`}>Privacy Policy</Link>
                        <Link to="/delete-account" className={` font-medium ${currentPath === "/delete-account" ? "text-[#E53935]" : "text-gray-900"}`}>Delete Account</Link>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                        </button>
                    </div>
                </nav>
            </header>
            <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                <div className="fixed inset-0 z-50 bg-gray-900 bg-opacity-50" />
                <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-64 bg-white p-5 shadow-lg">
                    {/* Close Button */}
                    <div className="flex items-center justify-between">
                        <Link to="/" className="text-lg font-semibold">Your Company</Link>
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="mt-5 space-y-3">
                        <ul className="space-y-2">
                            <li><Link className="text-gray-600 text-lg font-semibold flex justify-center items-center gap-2"><img className=" bg-gray-500 h-5 w-5 p-1 rounded-full " alt="call" src={call} />+91 97839 66966
                            </Link></li>
                            <li><Link to="/" className={` text-lg font-medium ${currentPath === "/" ? "text-[#E53935]" : "text-gray-900"}`} onClick={() => setMobileMenuOpen(false)}>Home</Link></li>
                            <li><Link to="/about" className={` text-lg font-medium ${currentPath === "/about" ? "text-[#E53935]" : "text-gray-900"}`} onClick={() => setMobileMenuOpen(false)}>About Us</Link></li>
                            <li><Link to="/privacy-policy" className={` text-lg font-medium ${currentPath === "/privacy-policy" ? "text-[#E53935]" : "text-gray-900"}`} onClick={() => setMobileMenuOpen(false)}>Privacy Policy</Link></li>
                            <li><Link to="/delete-account" className={` text-lg font-medium ${currentPath === "/delete-account" ? "text-[#E53935]" : "text-gray-900"}`} onClick={() => setMobileMenuOpen(false)}>Delete Account</Link></li>
                        </ul>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </>
    );
};

export default HomeHeader;